import http from "@http"

//列表  分页
export function getPictureList(data) {
    return http({
        url: '/lskj-document/api/document/picture/list',
        method: "post",
        data
    })
}
// 列表 不分页
export function getPictureAll(data) {
    return http({
        url: '/lskj-document/api/document/picture/all',
        method: "post",
        data
    })
}

//查询单条信息
export function pictureById(data) {
    return http({
        url: `/lskj-document/api/document/picture/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function pictureAdd(data) {
    return http({
        url: '/lskj-document/api/document/picture/add',
        method: "post",
        data
    })
}

//修改
export function updetePicture(data) {
    return http({
        url: `/lskj-document/api/document/picture`,
        method: "put",
        data
    })
}
//删除
export function deletePicture(data) {
    return http({
        url: `/lskj-document/api/document/picture?ids=${data.ids}`,
        method: "delete",
        data
    })
}